import Service from "./Service"

class SimpleInvoicePaymentPartService extends Service {

    createPaymentPart = (simpleInvoiceId, requestBody) => this.post(`/simple-invoices/${simpleInvoiceId}/payment-parts`, requestBody)

    deletePaymentPart = (id) => this.del(`/simple-invoices/payment-parts/${id}`)
}

const simpleInvoicePaymentPartService = new SimpleInvoicePaymentPartService()
export default simpleInvoicePaymentPartService